import http from "../../Services/Auth/config/http-common";
import ICatServicios from "../../Interfaces/Catalogos/ICatServicios";
import IRespuesta from "../../Interfaces/Respuestas/IRespuesta";

class CatServiciosDataService {
  Get() {
    return http.get<ICatServicios[]>("Catalogos/CatServicios/Get");
  }
  Append(data: ICatServicios) {
    return http.post<ICatServicios>(`Catalogos/CatServicios/Append`,data);
  }
  Delete(id: number) {
    return http.delete<IRespuesta>(`Catalogos/CatServicios/Delete/${id}`);
  }
}
export default new CatServiciosDataService();